// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3Ria6","emails":"CreateEditClinics_emails__39DZH","emailTagLabel":"CreateEditClinics_emailTagLabel__PDoXq"};